import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {SocialPostDesignActionPanelProps} from '@Components/panels/social-post-design-action-panel';
import {LazyPanel} from '@Components/lazy-panel';
import {useAppSelector} from '@/hooks';

export const PANEL_ID = 'social-post-design-action-panel';
export type SocialPostsDesignActionModalProps = SocialPostDesignActionPanelProps;

export default function SocialPostDesignActionModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.SOCIAL_POST_DESIGN_ACTION_MODAL];
  });

  const height = 'fit-content';
  const minHeight = '305px';
  const width = '784px';

  return (
    <Modal modalId={MODALS_IDS.SOCIAL_POST_DESIGN_ACTION_MODAL} modalHeight={height} panelId={PANEL_ID} modalWidth={width} modalMinHeight={minHeight}>
      <LazyPanel
        panelDirectoryName="social-post-design-action-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openDesignActionModal = (props: SocialPostsDesignActionModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_POST_DESIGN_ACTION_MODAL,
      panelProps: props,
    })
  );
};
